import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  id: "app_content"
};
import Head from "@/components/Head.vue";
import Base from "./components/Base.vue";
import { ref, onMounted, onBeforeUnmount } from 'vue';
import autofit from 'autofit.js';
export default {
  __name: 'App',
  setup(__props) {
    const screenWidth = ref(window.innerWidth);
    const screenHeight = ref(window.innerHeight);
    const isAutofitActive = ref(false);
    let autofitEnabled = false;
    const checkScreenSize = () => {
      screenWidth.value = window.innerWidth;
      screenHeight.value = window.innerHeight;

      // 只在屏幕宽度低于1200px时启用autofit
      if (screenWidth.value < 1200 && !autofitEnabled) {
        autofit.init({
          dh: 1080,
          dw: 1200,
          el: "#app",
          resize: true,
          allowScroll: false
        }, false);
        autofitEnabled = true;
        isAutofitActive.value = true;
      } else if (screenWidth.value >= 1200 && autofitEnabled) {
        autofit.off();
        autofitEnabled = false;
        isAutofitActive.value = false;
      }
    };

    // 防抖函数
    const debounce = (func, wait) => {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    };
    onMounted(() => {
      // 初始检查
      checkScreenSize();
      // 添加防抖的resize监听
      const debouncedCheck = debounce(checkScreenSize, 200);
      window.addEventListener('resize', debouncedCheck);
    });
    onBeforeUnmount(() => {
      if (autofitEnabled) {
        autofit.off();
      }
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Head), _createVNode(_component_router_view), _createVNode(Base)]);
    };
  }
};